export function useConstants() {
  return {
    QUERY_PARAMS: {
      suppliers: 's',
      categories: 'c',
      curativeTreatments: 't',
      manufacturers: 'm',
      dosageForms: 'd',
      saleDelimitations: 'l',
      typeOfApplications: 'a',
      ingredients: 'i',
      admissionSpecies: 'o',
      vaccines: 'v',
      query: 'q',
      categoriesNew: 'cn',
    } as const,

    CLINIC_CHAINS: {
      DEFAULT_COLOR: '#954a45',
      DEFAULT_GROUP_COLOR: '#F5A623',
      DEFAULT_GROUP_1_COLOR: '#34A853',
    } as const,
  }
}
